const PACK_FIRST_FLOW_FLAG = 'pack-first-flow'

export type CheckoutFlowExperimentVariant = 'control' | 'test'

export function useCheckoutFlowExperiment() {
  const flagVariant = useFeatureFlagVariantKey(PACK_FIRST_FLOW_FLAG)

  const isPackFirstFlow = computed(() => flagVariant.value === 'test')

  const experimentVariant = computed<CheckoutFlowExperimentVariant>(() =>
    isPackFirstFlow.value ? 'test' : 'control'
  )

  return { isPackFirstFlow, experimentVariant }
}
